
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("kbXjb"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("kbXjb", function(module, exports) {

let $03cb24807c9568b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03cb24807c9568b2$var$load("h3ABO"),
    $03cb24807c9568b2$var$load("a2Wil"),
    $03cb24807c9568b2$var$load("aNhGE"),
    $03cb24807c9568b2$var$load("djHM5"),
    $03cb24807c9568b2$var$load("eJQji"),
    $03cb24807c9568b2$var$load("2YffH"),
    $03cb24807c9568b2$var$load("9slUK"),
    $03cb24807c9568b2$var$load("6mHrv"),
    $03cb24807c9568b2$var$load("awWN9"),
    $03cb24807c9568b2$var$load("9CYct"),
    $03cb24807c9568b2$var$load("9QUT8"),
    $03cb24807c9568b2$var$load("5zRul"),
    $03cb24807c9568b2$var$load("hZtKG"),
    $03cb24807c9568b2$var$load("iNmaF"),
    $03cb24807c9568b2$var$load("lVO3w"),
    $03cb24807c9568b2$var$load("hyzoX"),
    $03cb24807c9568b2$var$load("h9Ed7"),
    $03cb24807c9568b2$var$load("eBRUf"),
    $03cb24807c9568b2$var$load("kbRvk"),
    $03cb24807c9568b2$var$load("9Vh0G"),
    $03cb24807c9568b2$var$load("hBIgN"),
    $03cb24807c9568b2$var$load("cD6Zr"),
    $03cb24807c9568b2$var$load("9wzNh"),
    $03cb24807c9568b2$var$load("8YSo7"),
    $03cb24807c9568b2$var$load("3Zfzp"),
    $03cb24807c9568b2$var$load("9ldRJ"),
    $03cb24807c9568b2$var$load("50ame"),
    $03cb24807c9568b2$var$load("eYWAR"),
    $03cb24807c9568b2$var$load("8z2kq"),
    $03cb24807c9568b2$var$load("ebWFc"),
    $03cb24807c9568b2$var$load("6iz6l"),
    $03cb24807c9568b2$var$load("4SCW2"),
    $03cb24807c9568b2$var$load("8bXcu"),
    $03cb24807c9568b2$var$load("1YiFu"),
    $03cb24807c9568b2$var$load("hv4mn"),
    $03cb24807c9568b2$var$load("Wowvf"),
    $03cb24807c9568b2$var$load("dek7I"),
    $03cb24807c9568b2$var$load("3SmkN"),
    $03cb24807c9568b2$var$load("dYtBN"),
    $03cb24807c9568b2$var$load("kNV5Y"),
    $03cb24807c9568b2$var$load("6wr18"),
    $03cb24807c9568b2$var$load("kjZZD"),
    $03cb24807c9568b2$var$load("2zxmz"),
    $03cb24807c9568b2$var$load("7269o"),
    $03cb24807c9568b2$var$load("3JSgG"),
    $03cb24807c9568b2$var$load("37ldp"),
    $03cb24807c9568b2$var$load("ffEVr"),
    $03cb24807c9568b2$var$load("dRpV3"),
    $03cb24807c9568b2$var$load("dTsOE"),
    $03cb24807c9568b2$var$load("hhss7"),
    $03cb24807c9568b2$var$load("jYUNl"),
    $03cb24807c9568b2$var$load("foy8I"),
    $03cb24807c9568b2$var$load("jY21r"),
    $03cb24807c9568b2$var$load("dP7ao"),
    $03cb24807c9568b2$var$load("hogcU"),
    $03cb24807c9568b2$var$load("i8eeg"),
    $03cb24807c9568b2$var$load("iFdoJ"),
    $03cb24807c9568b2$var$load("7EorR"),
    $03cb24807c9568b2$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.cabd6ce5.js.map
